import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from "@/config";
import { pests } from "@/api/api_url";
import { getToken, formatYMD } from "@/libs/util";
import { renderFormMixins } from "@/mixins/renderFormMixins";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmCityList from "vue-baidu-map/components/controls/CityList.vue";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch.vue";
import { area_list, get_merchant_all, device_about as _device_about } from "@/api/jingxiaoshang";
export default {
  name: "downloadCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      timeEareTemp: [],
      modelcodelist: {},
      merchantData: [],
      areaData: [],
      headers: {
        Authorization: getToken()
      },
      formModel: {
        start_time: null,
        end_time: null,
        timeEareTemp: []
      },
      formRules: {
        // area_codes:[{required: true,type:'array', message: '出货区域不能为空', trigger: 'blur'}
        // ],
        timeEareTemp: [{
          required: true,
          type: "array",
          message: this._vm.$t("devicelist.qishijieshunotnull"),
          trigger: "change"
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    projectCode: {}
  },
  computed: {},
  methods: {
    deviceRangeChange: function deviceRangeChange(arr) {
      //   this.$refs.refName.validate()
      if (arr) {
        var start = new Date(arr[0]).getTime();
        var end = new Date(arr[1]).getTime();
        start = start / 1000;
        end = end / 1000;
        console.log(start);
        console.log(end);
        this.$set(this.formModel, "start_time", start);
        this.$set(this.formModel, "end_time", end);
      }
    },
    device_about: function device_about(callback) {
      var _this = this;

      _device_about({}).then(function (res) {
        if (res.result === 0) {
          var data = res.body;
          _this.modelcodelist = data.model_code;

          if (callback) {
            callback();
          }
        }
      });
    },
    init: function init() {}
  },
  mounted: function mounted() {
    //debugger
    if (this.projectCode) {
      this.$set(this.formModel, "project_code", this.projectCode);
    } //alert(123);
    //获取区域列表


    if (this.edit) {//  this.device_about();
    }
  },
  created: function created() {
    //this.$set(this, 'modelcodelist', this.model_code_list);
    this.init();
  }
};